import React, { useState, useCallback } from "react";
import "~/css/Modal.css";
import GoogleMapComponent from "~/googlemap/GoogleMapComponent";
import "~/css/utils/Dropdown.css";
import { useTranslation } from "react-i18next";
import { googlemapCategories } from "~/Commons";
import { useAtom } from "jotai/index";
import { categoryAtom } from "~/Atom";

// 定数 / 型定義
const TRAVEL_MODES = ["WALKING", "DRIVING", "BICYCLING", "TRANSIT"] as const;
type TravelMode = (typeof TRAVEL_MODES)[number];

/**
 * Googleマップモーダルコンポーネント
 */
const GoogleMap: React.FC = () => {
  const { t } = useTranslation();
  const [travelMode, setTravelMode] = useState<TravelMode>("WALKING");
  const [category, setCategory] = useAtom(categoryAtom);

  /**
   * 交通手段変更ハンドラ
   *
   * @param e - イベントオブジェクト
   * @returns {void} 交通手段変更後の処理
   */
  const handleChangeTravelMode = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
    setTravelMode(e.target.value as TravelMode);
  }, []);

  /**
   * カテゴリ変更ハンドラ
   *
   * @param e - イベントオブジェクト
   * @returns {void} カテゴリ変更後の処理
   */
  const handleChangeCategory = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      setCategory(e.target.value);
    },
    [setCategory]
  );

  return (
    <>
      <div className={"dropdown-container"}>
        <div className={"custom-dropdown"}>
          <label htmlFor="travel-mode-select" className={"font-default-normal-20"}>
            {t("transportation")}:
          </label>
          <select
            id="travel-mode-select"
            className={"form-select"}
            value={travelMode}
            onChange={handleChangeTravelMode}
            aria-label={t("transportation") as string}
          >
            {TRAVEL_MODES.map((mode) => (
              <option key={mode} value={mode}>
                {t(mode)}
              </option>
            ))}
          </select>
          <div className={"custom-arrow"} />
        </div>
        <div className={"custom-dropdown"}>
          <label htmlFor="category-select" className={"font-default-normal-20"}>
            {t("category")}:
          </label>
          <select
            id="category-select"
            className={"form-select"}
            value={category}
            onChange={handleChangeCategory}
            aria-label={t("category") as string}
          >
            {googlemapCategories.map((cat) => (
              <option key={cat.value} value={cat.value}>
                {cat.label}
              </option>
            ))}
          </select>
          <div className={"custom-arrow"} />
        </div>
      </div>
      <GoogleMapComponent travelMode={travelMode} />
      <p>
        <small>{t("googlemapNotification")}</small>
      </p>
    </>
  );
};
export default GoogleMap;
